import React, { memo, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import { HeaderControlsStyled, HeaderStyled, TitleStyled } from "./styles";
import { AddMissionsDropdown } from "Components/MissionPlanner/components/AddMissionsDropdown";
import { LastUpdatedHeader } from "./LastUpdatedHeader";
import { getLastUpdateAt } from "Slices/missionsPage/selectors";
import { fetchMissions } from "Slices/missionsPage/actions";
import {
  LIVE_MISSIONS_PATH,
  QUEUE_MISSIONS_PATH,
} from "../../../../routers/AuthorizedRouter";
import { getCurrentFleetId } from "Slices/missionPlanner";
import { getIsMissionOperator } from "Slices/currentUser/selectors";
import { MissionListSearch } from "../MissionListSearch/MissionListSearch";
import { EmergencyStopButton } from "./EmergencyStopButton";

export const Header = memo(() => {
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const currentFleetId = useSelector(getCurrentFleetId);
  const lastUpdateAt = useSelector(getLastUpdateAt);
  const isMissionOperator = useSelector(getIsMissionOperator);

  const handleRefresh = () => {
    if (currentFleetId) {
      dispatch(fetchMissions({ currentFleetId }));
    }
  };

  const title = useMemo(() => {
    if (pathname === LIVE_MISSIONS_PATH) return "Live Missions";
    else if (pathname === QUEUE_MISSIONS_PATH) return "Queue Manager";
    else return "Missions";
  }, [pathname]);

  return (
    <HeaderStyled>
      <TitleStyled>{title}</TitleStyled>
      <HeaderControlsStyled>
        {pathname === LIVE_MISSIONS_PATH ? (
          <LastUpdatedHeader
            lastUpdated={lastUpdateAt ?? null}
            onRefresh={handleRefresh}
          />
        ) : (
          <MissionListSearch />
        )}
        {currentFleetId && !isMissionOperator && (
          <EmergencyStopButton fleetId={currentFleetId} />
        )}
        <AddMissionsDropdown />
      </HeaderControlsStyled>
    </HeaderStyled>
  );
});
